import React from 'react';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import SelectField from '../../../../../Components/Form/components/SelectField';
import FormCondition from '../../../../../Components/Form/FormCondition';
import WorkplaceOrWorkplaceMemberSelect from '../../../../Base/Components/WorkplaceOrWorkplaceMemberSelect/WorkplaceOrWorkplaceMemberSelect';
import FormControl from '../../../../../Components/Form/FormControl';
import { useAppContext } from '../../../../../Services/AppContext';
import InputWrapper from '../../../../../Components/Form/components/InputWrapper/InputWrapper';
import InfoTooltip from '../../../../../Components/Popup/InfoTooltip';
import Text from '../../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './PatientRegistrationFavoritePresetSelect.module.scss';
import { CreatedByType } from '../../../Enums/CreatedByType.enum';

export const createdByTypeOptions: SelectValue[] = [
	{
		label:
			'component.patientRegistrationFavoritePresetSelect.createdByTypeOptions.onMe',
		value: CreatedByType.ME,
	},
	{
		label:
			'component.patientRegistrationFavoritePresetSelect.createdByTypeOptions.onSomeoneElse',
		value: CreatedByType.USER,
	},
	{
		label:
			'component.patientRegistrationFavoritePresetSelect.createdByTypeOptions.onWorkplace',
		value: CreatedByType.WORKPLACE,
	},
];

const PatientRegistrationFavoritePresetSelect: React.FC = () => {
	const { workplaceId } = useAppContext();

	return (
		<div className={styles.wrapper}>
			<div className={styles.inputs}>
				<InputWrapper>
					<SelectField
						label='component.patientRegistrationFavoritePresetSelect.createdByType'
						name='createdByType'
						options={createdByTypeOptions}
						isRequired
					/>
				</InputWrapper>
				<FormCondition controlName='createdByType' equal='USER'>
					<InputWrapper>
						<FormControl
							name='createdById'
							label='component.patientRegistrationFavoritePresetSelect.createdById'
							isRequired>
							<WorkplaceOrWorkplaceMemberSelect
								filter={{
									workplaceId,
									searchWorkplaceMembersOnly: true,
								}}
								includeNurses={false}
							/>
						</FormControl>
					</InputWrapper>
				</FormCondition>
			</div>
			<div className={styles.tooltipWrapper}>
				<InfoTooltip>
					<Text tx='component.patientRegistrationFavoritePresetSelect.tooltip' />
				</InfoTooltip>
			</div>
		</div>
	);
};

export default PatientRegistrationFavoritePresetSelect;
